import { isMobileAtom, useRecoil } from '@orcar/common-d2c';
import {
  List,
  ListWrapper,
  Section,
  SectionSubTitle,
  SectionTitle,
  Text,
} from '@/components/InformationStyles';
import { ContentWrapper } from '@/components/reservationDetails/commonStyles';

const TravelPolicy = () => {
  const { recoilValue: isMobile } = useRecoil(isMobileAtom);

  return (
    <ContentWrapper>
      <SectionTitle isMobile={isMobile}>국내 여행 약관</SectionTitle>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제1조(목적)</SectionSubTitle>
        <Text>
          이 약관은 (주)제주로렌트카와 여행자가 체결한 국내여행계약의 세부이행
          및 준수사항을 정함을 목적으로 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제2조(여행업자와 여행자 의무)</SectionSubTitle>
        <Text>
          여행업자는 여행자에게 안전하고 만족스러운 여행서비스를 제공하기 위하여
          여행알선 및 안내ㆍ운송ㆍ숙박 등 여행계획의 수립 및 실행과정에서 맡은
          바 임무를 충실히 수행하여야 합니다.
        </Text>
        <Text>
          여행자는 안전하고 즐거운 여행을 위하여 여행자간 화합도모 및 여행업자의
          여행질서 유지에 적극 협조하여야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>
          제3조(여행의 종류 및 정의)여행의 종류와 정의는 다음과 같습니다.
        </SectionSubTitle>
        <Text>
          희망여행 : 여행자가 희망하는 여행조건에 따라 여행업자가 실시하는 여행
        </Text>
        <Text>
          일반모집여행 : 여행업자가 수립한 여행조건에 따라 여행자를 모집하여
          실시하는 여행
        </Text>
        <Text>
          위탁모집여행 : 여행업자가 만든 모집여행상품의 여행자 모집을 타
          여행업체에 위탁하여 실시하는 여행
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제4조(계약의 구성)</SectionSubTitle>
        <Text>
          여행계약은 여행계약서(붙임)와 여행약관ㆍ여행일정표(또는 여행 설명서)를
          계약내용으로 합니다
        </Text>
        <Text>
          여행일정표(또는 여행설명서)에는 여행일자별 여행지와
          관광내용ㆍ교통수단ㆍ쇼핑횟수ㆍ숙박장소ㆍ식사 등 여행실시일정 및 여행사
          제공 서비스 내용과 여행자 유의사항이 포함되어야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제5조(특약)</SectionSubTitle>
        <Text>
          여행업자와 여행자는 관계법규에 위반되지 않는 범위내에서 서면으로
          특약을 맺을 수 있습니다. 이 경우 표준약관과 다름을 여행업자는
          여행자에게 설명하여야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제6조(계약서 및 약관 등 교부)</SectionSubTitle>
        <Text>
          여행업자는 여행자와 여행계약을 체결한 경우 계약서와 여행약관,
          여행일정표(또는 여행설명서)를 각 1부씩 여행자에게 교부하여야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제7조(계약서 및 약관 등 교부 간주)</SectionSubTitle>
        <Text>
          다음 각 호의 경우에는 여행업자가 여행자에게 여행계약서와 여행약관 및
          여행일정표(또는 여행설명서)가 교부된 것으로 간주합니다.
        </Text>
        <ListWrapper>
          <List>
            여행자가 인터넷 등 전자정보망으로 제공된 여행계약서, 약관 및
            여행일정표(또는 여행설명서)의 내용에 동의하고 여행계약의 체결을
            신청한데 대해 여행업자가 전자정보망 내지 기계적 장치 등을 이용하여
            여행자에게 승낙의 의사를 통지한 경우
          </List>
          <List>
            여행업자가 팩시밀리 등 기계적 장치를 이용하여 제공한 여행계약서,
            약관 및 여행일정표(또는 여행설명서)의 내용에 대하여 여행자가
            동의하고 여행계약의 체결을 신청하는 서면을 송부한데 대해 여행업자가
            전자정보망 내지 기계적 장치 등을 이용하여 여행자에게 승낙의 의사를
            통지한 경우
          </List>
        </ListWrapper>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제8조(여행업자의 책임)</SectionSubTitle>
        <Text>
          여행업자는 여행 출발시부터 도착시까지 여행업자 본인 또는 그 고용인,
          현지여행업자 또는 그 고용인 등(이하 ‘사용인’이라 함)이 제2조제1항에서
          규정한 여행업자 임무와 관련하여 여행자에게 고의 또는 과실로 손해를
          가한 경우 책임을 집니다.
        </Text>
        <Text>
          여행업자는 항공기, 기차, 선박 등 교통기관의 연발착 또는 교통체증
          등으로 인하여 여행자가 입은 손해를 배상하여야 합니다. 단 여행업자가
          고의 또는 과실이 없음을 입증한 때에는 그러하지 아니합니다.
        </Text>
        <Text>
          여행업자는 자기나 그 사용인이 여행자의 수화물 수령ㆍ인도ㆍ보관 등에
          관하여 주의를 해태하지 아니하였음을 증명하지 아니 하는 한 여행자의
          수화물 멸실, 훼손 또는 연착으로 인하여 발생한 손해를 배상하여야
          합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>
          제9조(최저 행사인원 미 충족시 계약해제)
        </SectionSubTitle>
        <Text>
          여행업자는 최저행사인원이 충족되지 아니하여 여행계약을 해제하는 경우
          당일여행의 경우 여행출발 24시간 이전까지, 1박2일 이상인 경우에는
          여행출발 48시간 이전까지 여행자에게 통지하여야 합니다.
        </Text>
        <Text>
          여행업자가 여행참가자 수의 미달로 전항의 기일내 통지를 하지 아니하고
          계약을 해제하는 경우 이미 지급받은 계약금 환급 외에 계약금 100%
          상당액을 여행자에게 배상하여야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제10조(계약체결 거절)</SectionSubTitle>
        <Text>
          여행업자는 여행자에게 다음 각 호의 1에 해당하는 사유가 있을 경우에는
          여행자와의 계약체결을 거절할 수 있습니다.
        </Text>
        <ListWrapper>
          <List>
            다른 여행자에게 폐를 끼치거나 여행의 원활한 실시에 지장이 있다고
            인정될 때
          </List>
          <List>질병 기타 사유로 여행이 어렵다고 인정될 때</List>
          <List>계약서에 명시한 최대행사인원이 초과되었을 때</List>
        </ListWrapper>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제11조(여행요금)</SectionSubTitle>
        <Text>
          기본요금에는 다음 각 호가 포함됩니다. 단, 희망여행은 당사자간 합의에
          따릅니다.
        </Text>
        <ListWrapper>
          <List>항공기, 선박, 철도 등 이용운송기관의 운임(보통운임기준)</List>
          <List>공항, 역, 부두와 호텔사이 등 송영버스요금</List>
          <List>숙박요금 및 식사요금</List>
          <List>안내자경비</List>
          <List>여행 중 필요한 각종 세금</List>
          <List>국내 공항ㆍ항만 이용료</List>
          <List>일정표내 관광지 입장료</List>
          <List>기타 개별계약에 따른 비용</List>
        </ListWrapper>
        <Text>
          여행자는 계약 체결시 계약금(여행요금 중 10%이하의 금액)을 여행업자에게
          지급하여야 하며, 계약금은 여행요금 또는 손해배상액의 전부 또는 일부로
          취급합니다.
        </Text>
        <Text>
          여행자는 제1항의 여행요금 중 계약금을 제외한 잔금을 여행출발 전일까지
          여행업자에게 지급하여야 합니다.
        </Text>
        <Text>
          여행자는 제1항의 여행요금을 여행업자가 지정한 방법(지로구좌, 무통장
          입금 등)으로 지급하여야 합니다.
        </Text>
        <Text>
          희망여행요금에 여행자 보험료가 포함되는 경우 여행업자는 보험회사명,
          보상내용 등을 여행자에게 설명하여야 합니다
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>
          제12조(여행조건의 변경요건 및 요금 등의 정산)
        </SectionSubTitle>
        <Text>
          위 제1조 내지 제11조의 여행조건은 다음 각 호의 1의 경우에 한하여
          변경될 수 있습니다.
        </Text>
        <ListWrapper>
          <List>
            여행자의 안전과 보호를 위하여 여행자의 요청 또는 현지사정에 의하여
            부득이하다고 쌍방이 합의한 경우
          </List>
          <List>
            천재지변, 전란, 정부의 명령, 운송ㆍ숙박기관 등의 파업?휴업 등으로
            여행의 목적을 달성할 수 없는 경우
          </List>
        </ListWrapper>
        <Text>
          제1항의 여행조건 변경으로 인하여 제11조제1항의 여행요금에 증감이
          생기는 경우에는 여행출발 전 변경 분은 여행출발 이전에, 여행 중 변경
          분은 여행종료 후 10일 이내에 각각 정산(환급)하여야 합니다.
        </Text>
        <Text>
          제1항의 규정에 의하지 아니하고 여행조건이 변경되거나 제13조 또는
          제14조의 규정에 의한 계약의 해제ㆍ해지로 인하여 손해배상액이 발생한
          경우에는 여행출발 전 발생 분은 여행출발이전에, 여행 중 발생 분은 여행
          종료 후 10일 이내에 각각 정산(환급)하여야 합니다.
        </Text>
        <Text>
          여행자는 여행출발후 자기의 사정으로 숙박, 식사, 관광 등 여행요금에
          포함된 서비스를 제공받지 못한 경우 여행업자에게 그에 상응하는 요금의
          환급을 청구할 수 없습니다. 단, 여행이 중도에 종료된 경우에는 제14조에
          준하여 처리합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제13조(여행출발 전 계약해제)</SectionSubTitle>
        <Text>
          여행업자 또는 여행자는 여행출발전 이 여행계약을 해제할 수 있습니다. 이
          경우 발생하는 손해액은 ‘소비자피해보상규정’(재정경제부고시)에 따라
          배상합니다.
        </Text>
        <Text>
          여행업자 또는 여행자는 여행출발 전에 다음 각 호의 1에 해당하는 사유가
          있는 경우 상대방에게 제1항의 손해배상액을 지급하지 아니하고 이
          여행계약을 해제할 수 있습니다.
        </Text>
        <Text>여행업자가 해제할 수 있는 경우</Text>
        <ListWrapper>
          <List>제12조제1항제1호 및 제2호사유의 경우</List>
          <List>
            여행자가 다른 여행자에게 폐를 끼치거나 여행의 원활한 실시에 현저한
            지장이 있다고 인정될 때
          </List>
          <List>
            질병 등 여행자의 신체에 이상이 발생하여 여행에의 참가가 불가능한
            경우
          </List>
          <List>
            여행자가 계약서에 기재된 기일까지 여행요금을 지급하지 아니하는 경우
          </List>
        </ListWrapper>
        <Text>여행자가 해제할 수 있는 경우</Text>
        <ListWrapper>
          <List>제12조제1항제1호 및 제2호사유의 경우</List>
          <List>여행자의 3촌이내 친족이 사망한 경우</List>
          <List>
            질병 등 여행자의 신체에 이상이 발생하여 여행에의 참가가 불가능한
            경우
          </List>
          <List>
            배우자 또는 직계존비속이 신체이상으로 3일 이상 병원(의원)에 입원하여
            여행 출발시까지 퇴원이 곤란한 경우 그 배우자 또는 보호자 1인
          </List>
          <List>
            여행업자의 귀책사유로 계약서에 기재된 여행일정대로의 여행실시가
            불가능해진 경우
          </List>
        </ListWrapper>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제14조(여행출발 후 계약해지)</SectionSubTitle>
        <Text>
          여행업자 또는 여행자는 여행출발 후 부득이한 사유가 있는 경우 이 계약을
          해지할 수 있습니다. 단, 이로 인하여 상대방이 입은 손해를 배상하여야
          합니다.
        </Text>
        <Text>
          제1항의 규정에 의하여 계약이 해지된 경우 여행업자는 여행자가
          귀가하는데 필요한 사항을 협조하여야 하며, 이에 필요한 비용으로서
          여행업자의 귀책사유에 의하지 아니한 것은 여행자가 부담합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제15조(여행의 시작과 종료)</SectionSubTitle>
        <Text>
          여행의 시작은 출발하는 시점부터 시작하며 여행일정이 종료하여
          최종목적지에 도착함과 동시에 종료합니다. 다만, 계약 및 일정을 변경할
          때에는 예외로 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제16조(설명의무)</SectionSubTitle>
        <Text>
          여행업자는 이 약관에 정하여져 있는 중요한 내용 및 그 변경사항을
          여행자가 이해할 수 있도록 설명하여야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제17조(보험가입 등)</SectionSubTitle>
        <Text>
          여행업자는 여행과 관련하여 여행자에게 손해가 발생 한 경우 여행자에게
          보험금을 지급하기 위한 보험 또는 공제에 가입하거나 영업 보증금을
          예치하여야 합니다.
        </Text>
      </Section>
      <Section isMobile={isMobile}>
        <SectionSubTitle>제18조(기타사항)</SectionSubTitle>
        <Text>
          {' '}
          이 계약에 명시되지 아니한 사항 또는 이 계약의 해석에 관하여 다툼이
          있는 경우에는 여행업자와 여행자가 합의하여 결정하되, 합의가 이루어지지
          아니한 경우에는 관계법령 및 일반관례에 따릅니다.
        </Text>
        <Text>
          특수지역에의 여행으로서 정당한 사유가 있는 경우에는 약관의 내용과
          다르게 정할 수 있습니다.
        </Text>
      </Section>
    </ContentWrapper>
  );
};

export default TravelPolicy;
